import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import dayjs from 'dayjs'

import {
  Box,
  TextField,
  Button,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Autocomplete from '@material-ui/lab/Autocomplete'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import dow from 'common/utils/dow'
import theme from 'common/theme'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  inputBox: {
    marginBottom: theme.spacing(3),
  },
  specialtiesContainer: {
    display: 'flex',
    alignItems: 'end',
  },
  specialties: {
    flex: '1',
    marginRight: theme.spacing(1),
  },
}))

const ScheduleSlotModal = ({
  isOpen,
  onSubmit,
  onClose,
  specialties,
  info,
  onDelete,
  schedule,
  timezone,
}) => {
  const classes = useStyles()
  const [selectedSpecialties, setSelectedSpecialties] = useState([])
  const [selectedDuration, setSelectedDuration] = useState(30)
  const [defaultValues, setDefaultValues] = useState([])

  useEffect(() => {
    if (!schedule) return

    setDefaultValues(schedule.specialties || [])
    setSelectedDuration(schedule.duration)
  }, [schedule])

  useEffect(() => {
    if (schedule) return

    setDefaultValues([])
    setSelectedDuration(30)
    setSelectedSpecialties([])
  }, [isOpen])

  const submit = () => {
    const startStr = dayjs.tz(info.startStr, timezone).format()
    const data = {
      start: startStr,
      end:
        selectedDuration >
        dayjs(info.endStr).diff(dayjs(info.startStr), 'minutes')
          ? dayjs(startStr).add(selectedDuration, 'minutes').format()
          : dayjs.tz(info.endStr, timezone).format(),
      specialties: selectedSpecialties,
      duration: selectedDuration,
    }
    onSubmit(data)
  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        {info && (
          <>
            {dow[info.start.getDay()]} de{' '}
            {dayjs(info.startStr).format('h:mm a')} hasta{' '}
            {dayjs(info.endStr).format('h:mm a')}
          </>
        )}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Seleccioná una o más especialidades y la duración de los turnos.
        </DialogContentText>
        <Box className={clsx(classes.inputBox, classes.specialtiesContainer)}>
          <Autocomplete
            className={classes.specialties}
            disabled={schedule && schedule.exists}
            multiple
            id='selectedSpecialties'
            options={specialties}
            getOptionLabel={(option) => option.name}
            filterSelectedOptions
            disableCloseOnSelect
            defaultValue={defaultValues}
            onChange={(e, v) => {
              setSelectedSpecialties(v)
            }}
            value={selectedSpecialties}
            renderInput={(params) => (
              <TextField
                name='selectedSpecialties'
                {...params}
                label='Especialidades'
                fullWidth
              />
            )}
          />
          <IconButton
            onClick={() => setSelectedSpecialties(specialties)}
            color='primary'
            size='small'
            disabled={schedule && schedule.exists}
          >
            <DoneAllIcon />
          </IconButton>
        </Box>
        <Box className={classes.inputBox}>
          <TextField
            disabled={schedule && schedule.exists}
            select
            label='Duración del Turno'
            value={selectedDuration}
            onChange={(e) => setSelectedDuration(e.target.value)}
            helperText='Seleccione la duración del turno'
          >
            {[15, 30, 45, 60, 75, 90, 105, 120].map((option) => (
              <MenuItem
                key={option}
                value={option}
                disabled={option > info?.maximumDuration}
              >
                {option} minutos
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        {info && info.id && (
          <Button onClick={onDelete} style={theme.danger}>
            Remover
          </Button>
        )}
        <Button onClick={onClose} color='primary'>
          Volver
        </Button>
        <Button
          onClick={submit}
          color='primary'
          variant='contained'
          disabled={
            !selectedSpecialties.length ||
            !selectedDuration ||
            (schedule && schedule.exists)
          }
        >
          Seleccionar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ScheduleSlotModal.defaultProps = {
  duration: 30,
}

const mapStateToProps = (state) => {
  return {}
}

export default connect(mapStateToProps, {})(ScheduleSlotModal)
